import { gql } from '@apollo/client'

export const UPDATE_EMPLOYEE_PREFERENCES = gql`
    mutation updateEmployeePreferences(
        $preferences: EmployeePreferencesInput!
    ) {
        updateEmployeePreferences(preferences: $preferences)
    }
`
